import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

export class CatalogFacetsProxy {
    /** POST catalog/items/facets — disjunctive facet counts for a CatalogQuery-shaped body. */
    async facets(query = {}) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/catalog/items/facets`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(query),
        });
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    /** Tags for a category (or the whole catalog when no categoryId), ordered by count. */
    async topTags(categoryId, limit) {
        const { facets } = await this.facets(categoryId ? { categoryId } : {});
        const entries = Object.entries(facets?.tags ?? {}).sort((a, b) => b[1] - a[1]);
        return entries.slice(0, limit ?? entries.length).map(([tag]) => tag);
    }
}
